type UserRedirectInfo = {
  primaryCommunityId?: number | null
  redirectAfterFirstLogin?: string | null
  shouldBeRedirectedOnLogOn?: boolean
}

type CommunityInfo = {
  id?: number
}

/**
 * Determines where to redirect the user after login based on their user data
 * and community membership (from /api/User/GetMyStuff).
 *
 * Priority:
 * 1. Backend-specified first-login redirect (e.g., after signup via application)
 * 2. Primary community, but ONLY if it exists in the user's GetMyStuff communities
 * 3. /account/profile fallback when primary community is missing or not in communities list
 */
export function getPostLoginRedirect(
  user: UserRedirectInfo | null | undefined,
  communities: CommunityInfo[] | null | undefined,
): string {
  if (!user) return "/account/profile"

  // 1. If backend indicates a first-login redirect
  if (user.shouldBeRedirectedOnLogOn && user.redirectAfterFirstLogin) {
    return user.redirectAfterFirstLogin
  }

  // 2. If user has a primary community that exists in their communities list
  if (
    user.primaryCommunityId != null &&
    communities?.some((c) => c.id === user.primaryCommunityId)
  ) {
    return `/community/${user.primaryCommunityId}`
  }

  // 3. Primary community not present or not in communities list
  return "/account/profile"
}
